import { AbstractStorage } from "./AbstractStorage.js";
class FallbackStorage extends AbstractStorage {
  fallbackStore;
  constructor(store, fallbackStore) {
    super(store);
    this.fallbackStore = fallbackStore;
  }
  get(key) {
    return this.store.get(key) ?? this.fallbackStore.get(key);
  }
  set(key, value) {
    this.store.set(key, value);
    this.fallbackStore.set(key, value);
  }
  has(key) {
    return this.store.has(key) || this.fallbackStore.has(key);
  }
  delete(key) {
    this.store.delete(key);
    this.fallbackStore.delete(key);
  }
}
export {
  FallbackStorage
};
//# sourceMappingURL=FallbackStorage.js.map
